import React from 'react'
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import { GatsbyImage } from "gatsby-plugin-image"
import { PageHeaderWrap } from '../pageheader/page-header.style';

const PageHeaderCustomBg = ({ pageContext, location, title, image, crumbLabel, textColor = '#f6f2ed' }) => {
    const { breadcrumb: { crumbs } } = pageContext;
    const disableLinks = [
        "/elements",
        "/category",
        "/profile",
        "/date",
        "/tag",
        "/page",
        "/blog",
        "/blog/page",
        "/blogs"
    ]
    const customCrumbLabel = location.pathname.toLowerCase();
    const crumbLabelArr = customCrumbLabel.split('/');
    const label = crumbLabelArr[crumbLabelArr.length - 1]
    const labelArr = label.split('-');

    const restProps = {
        textColor
    }

    return (
        <PageHeaderWrap textColor={textColor}>
            {image && (
                <GatsbyImage
                    image={image}
                    alt=""
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }}
                />
            )}
            <div style={{ position: "relative", zIndex: 1 }}>
                <Breadcrumb
                    title={title}
                    crumbs={crumbs}
                    crumbLabel={crumbLabel ?? labelArr.join(' ')}
                    disableLinks={disableLinks}
                />
            </div>
        </PageHeaderWrap>
    )
}

export default PageHeaderCustomBg
